import {s_char_talents} from "../../_signals/s_char";

export const getCastingTalent=()=> {
    const talents = s_char_talents.value;
    const found= talents.find((s) => s.name === "Spruchzauberei");
    return found??null
}